import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import React, { useState } from "react";
import { putCustomerPackageOffer } from "../../../services/CustomerPackageOffer/CustomerPackageOffer";

const ConfirmPackageStatusChange = ({
  confirmPackageStatusChangeVisible,
  setConfirmPackageStatusChangeVisible,
  sendDataToCustomerPackage,
  confirmPackageStatusChangeItem,
  brandId,
  storeId,
  storeCustomerId,
}) => {
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

  const handleConfirmation = () => {
    setIsSubmitButtonPressed(true);
    // Update the specific field in editCustomerData
    let updatedData = {
      status:
        confirmPackageStatusChangeItem?.status === "ACTIVE"
          ? "INACTIVE"
          : confirmPackageStatusChangeItem?.status === "PROSPECTIVE"
            ? "ACTIVE"
            : "",
      brandPackageOffer: {
        id: confirmPackageStatusChangeItem.brandPackageOffer.id,
      },
      storeCustomerId: storeCustomerId,
      id: confirmPackageStatusChangeItem.id,
    };
    
    putCustomerPackageOffer(brandId, storeId, updatedData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            sendDataToCustomerPackage({
              success: true,
            });
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    setIsSubmitButtonPressed(false);
    setConfirmPackageStatusChangeVisible(false);
  };

  const handleModalClose = () => {
    setIsSubmitButtonPressed(false);

    setConfirmPackageStatusChangeVisible(!confirmPackageStatusChangeVisible);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={confirmPackageStatusChangeVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!confirmPackageStatusChangeVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column  "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div></div>

              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Customer Package Offer
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 "
              ></Button>
            </div>

            <div className="flex-auto mt-1 mx-4">
              <p
                className=" text-center font-semibold text-2xl block"
                style={{ color: "red" }}
              >
                Please Confirm Do You Want
                {confirmPackageStatusChangeItem?.status === "ACTIVE"
                  ? " To INACTIVE "
                  : confirmPackageStatusChangeItem?.status === "PROSPECTIVE"
                    ? " To ACTIVE "
                    : " "}
                    This Package
              </p>
            </div>

             

            <div className="flex flex-1 mt-2">
              <Button
                onClick={handleConfirmation}
                disabled={isSubmitButtonPressed}
                className="flex-1 mt-1 mb-3 mx-4 p-1 border-round-xl "
              >
                <p className=" w-full text-2xl font-semibold flex justify-content-center">
                  Yes
                </p>
              </Button>
              <Button
                onClick={() => {
                   handleModalClose() }}
                disabled={isSubmitButtonPressed}
                className="flex-1 mt-1 mb-3 mx-4 p-1 border-round-xl "
              >
                <p className=" w-full text-2xl font-semibold flex justify-content-center">
                  No
                </p>
              </Button>
            </div>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default ConfirmPackageStatusChange;
